import React from 'react';

import EqualizerIcon from '@material-ui/icons/Equalizer';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';

import { AUClientLogin, PRODUCT_IDS } from '@assertiva/assertiva-ui';
import Dashboard from './components/dashboard/Dashboard';
import Settings from './components/settings/Settings';

const routes = [
  {
    id: 0,
    exact: true,
    path: '/',
    label: 'Login',
    redirect: '/dashboard',
    isPrivate: false,
    component: (props) => <AUClientLogin {...props} />,
  },
  {
    id: 2,
    exact: true,
    path: '/dashboard',
    label: 'Geotimize',
    isPrivate: true,
    showInMenu: true,
    startOpen: true,
    productId: PRODUCT_IDS.GEOTIMIZE,
    nested: [
      {
        id: 3,
        exact: true,
        path: '/dashboard',
        icon: <EqualizerIcon />,
        label: 'Novo Estudo',
        isPrivate: true,
        showInMenu: true,
        component: (props) => <Dashboard {...props} />,
      },
      {
        id: 3,
        exact: true,
        path: '/configuracoes',
        icon: <SettingsOutlinedIcon />,
        label: 'Configurações',
        isPrivate: true,
        showInMenu: true,
        component: (props) => <Settings {...props} />,
      },
    ],
  },
];

export default routes;
